document.addEventListener('alpine:init', () => {
  function cssSetProperty(data = {}) {
    return {
      ...data,
  
      init() {
        this.kickoff();

        if (this.useMutationObserver) {
          var observer = new MutationObserver(() => this.kickoff()); 

          observer.observe(this.$el, { subtree: true, childList: true });
        }
      },

      kickoff() {
        if (this.useClone) {
          var cloneContainerEl = document.createElement('div');

          cloneContainerEl.setAttribute('x-ignore', '');
          cloneContainerEl.style.overflow = 'hidden';
          cloneContainerEl.style.height = '0';

          var cloneEl = this.$el.cloneNode(true);

          cloneContainerEl.append(cloneEl);

          document.body.append(cloneContainerEl);

          this.setProperty(cloneEl);

          return cloneContainerEl.remove();
        }

        this.setProperty(this.$el);
      },

      setProperty(el) {
        document.documentElement.style.setProperty(this.name, `${el[this.value]}${this.valueSuffix}`);
      }
    };
  };
  
  Alpine.data('cssSetProperty', cssSetProperty);
});
